import { Injectable } from '@angular/core';

/**
 * The browser globals a component would otherwise reach for directly.
 *
 * `window.open`, `location.href`, `location.reload` and `alert` all either navigate the karma
 * runner away or block it on a modal dialog, so a component that calls them cannot be
 * instantiated in a unit test. Injecting them keeps the call sites honest and lets a spec
 * assert what was opened instead of suffering it.
 */
@Injectable({providedIn: 'root'})
export class BrowserService
{
    /** Open a URL in a new tab or the named target. */
    open(url: string, target: string = '_blank'): void
    {
        window.open(url, target);
    }

    /** Leave the app for the given URL — an external site, or a `mailto:`. */
    navigate(url: string): void
    {
        window.location.href = url;
    }

    /** Hard reload of the current page. */
    reload(): void
    {
        window.location.reload();
    }

    /** A blocking browser alert. */
    alert(message: string): void
    {
        window.alert(message);
    }
}
